import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import * as moment from 'moment';
import { Glyphicon, Button } from 'react-bootstrap';
import { IReportState, ISwapQualityIssueReportResponse, IApplicationState, AppActionCreators, ReportActionCreators } from '@nkr/store/index';
import { TableWrapper, HeaderColumnWrapper } from './styles';
import DonorSurgeonRow from './donor-surgeon-row';
import DownloadReport from './download-report';
import * as DateTimeModule from 'react-datetime';

const DateTime = (DateTimeModule as any).default;

interface IOwnProps { }

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getSwapQualityIssueReport: (startDate: string, endDate: string) => Promise<ISwapQualityIssueReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface ISortBy {
    property: string,
    direction: string
}

interface IState {
    expandedRows: number[],
    export: boolean,
    startDate: string,
    endDate: string,
    sortBy: ISortBy[]
}

class SwapQualityIssues extends React.Component<TProps, IState> {
    readonly state: IState = {
        expandedRows: [],
        export: false,
        startDate: __ENVIRONMENT__ == 'dev' ? '01/01/2016' : moment().subtract(6, 'months').format('MM/DD/YYYY'),
        endDate: __ENVIRONMENT__ == 'dev' ? '04/30/2018' : moment().format('MM/DD/YYYY'),
        sortBy: []
    }

    componentWillMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getSwapQualityIssueReport(this.state.startDate, this.state.endDate).then((response: ISwapQualityIssueReportResponse) => {
                this.props.hideLoading();
            });
        });
    }

    handleStartDateChange = (e: moment.Moment | string) => {
        let value = typeof e == 'string' ? e : e.format('MM/DD/YYYY');

        this.setState({
            startDate: value
        });
    }

    handleEndDateChange = (e: moment.Moment | string) => {
        let value = typeof e == 'string' ? e : e.format('MM/DD/YYYY');

        this.setState({
            endDate: value
        });
    }

    handleRefresh = () => {
        this.getData();
    }

    handleExpand = (id: number, expanded: boolean) => {
        let expandedRows = [...this.state.expandedRows];

        if (expanded)
            expandedRows = this.state.expandedRows.filter(item => item != id);
        else
            expandedRows.push(id);

        this.setState({
            expandedRows
        });
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);
        let sort = sortBy.find(item => item.property == property);

        if (sort != null) {
            if (sort.direction == 'asc')
                sort.direction = 'desc'
            else
                if (sort.direction == 'desc')
                    sortBy = [];
        } else {
            sortBy = [{ property, direction: 'asc' }];
        }
        this.setState({
            sortBy
        });
    }

    renderHeaderSort = (property: string) => {
        let sortItem = this.state.sortBy.find(item => item.property == property);

        if (sortItem != null) {
            return <Glyphicon glyph={sortItem.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    

    render = () => {
        const donorSurgeons = this.props.reports.swapQualityIssueReport.donorSurgeons.filter(surgeon => surgeon.issueCount > 0);
        const sortByProperties = this.state.sortBy.map((sortBy) => sortBy.property);
        const sortByDirections = this.state.sortBy.map((sortBy) => sortBy.direction);
        const sortedDonorSurgeons = this.state.sortBy.length > 0 ? _.orderBy(donorSurgeons, sortByProperties, sortByDirections) : donorSurgeons;

        const numericHeaderStyle = {
            width: '19.7%', 
            textAlign: 'center'
        }

        return (
            <>
                <div style={{ fontSize: 28, fontWeight: 500, marginBottom: 20 }}>Swap Quality Issues</div>

                <div className='well well-sm' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 14 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: 5 }}>Start Date:</div>
                        <div style={{ marginRight: 20 }}>
                            <DateTime
                                value={this.state.startDate}
                                input={true}
                                dateFormat={'MM/DD/YYYY'}
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{ style: { width: 140 } }}
                                onChange={this.handleStartDateChange}
                            />
                        </div>

                        <div style={{ marginRight: 5 }}>End Date:</div>
                        <div style={{ marginRight: 10 }}>
                            <DateTime
                                value={this.state.endDate}
                                input={true}
                                dateFormat={'MM/DD/YYYY'}
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{ style: { width: 140 } }}
                                onChange={this.handleEndDateChange}
                            />
                        </div>

                        <div>
                            <Button bsStyle='primary' onClick={this.handleRefresh}>Refresh</Button>
                        </div>
                    </div>

                    <DownloadReport
                        data={{
                            donorSurgeons: sortedDonorSurgeons,
                            issues: this.props.reports.swapQualityIssueReport.issues
                        }}
                    />
                </div>

                <TableWrapper condensed striped>
                    <thead>
                        <tr>
                            <th style={{ width: 20 }}></th>
                            <th style={{ textAlign: 'center' }}>R#</th>
                            <HeaderColumnWrapper style={{ width: '19.7%' }} onClick={() => this.handleSort('centerAlias')}>
                                Donor Center {this.renderHeaderSort('centerAlias')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '19.7%' }} onClick={() => this.handleSort('fullName')}>
                                Donor Surgeon {this.renderHeaderSort('fullName')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={numericHeaderStyle} onClick={() => this.handleSort('issueCount')}>
                                Recipient Center Issues {this.renderHeaderSort('issueCount')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={numericHeaderStyle} onClick={() => this.handleSort('count')}>
                                Nephrectomy Count {this.renderHeaderSort('count')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={numericHeaderStyle} onClick={() => this.handleSort('issueRate')}>
                                Issue Rate {this.renderHeaderSort('issueRate')}
                            </HeaderColumnWrapper>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedDonorSurgeons.map((donorSurgeon, index) => {
                            const issues = this.props.reports.swapQualityIssueReport.issues.filter(item => item.donorSurgeon == donorSurgeon.id);

                            return (
                                <DonorSurgeonRow
                                    key={index}
                                    data={{ donorSurgeon, issues, rNum: index + 1 }}
                                    expanded={this.state.expandedRows.find(item => item == donorSurgeon.id) != null}
                                    onExpand={this.handleExpand}
                                />
                            );
                        })}

                        {sortedDonorSurgeons.length == 0 ?
                            <tr>
                                <td colSpan={6}>
                                    <span style={{ fontStyle: 'italic' }}>We couldn't find any swap quality issues for the dates specified...</span>
                                </td>
                            </tr>
                            : null}
                    </tbody>
                </TableWrapper>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getSwapQualityIssueReport: (startDate, endDate) => {
            return dispatch(ReportActionCreators.getSwapQualityReport(startDate, endDate));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(SwapQualityIssues);